import { defineStore } from 'pinia'
import { useProductsStore } from '@/stores/products'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    loading: false,
    initialized: false,
    hideFilter: window.app.model_list.hideFilter,
  }),
  getters: {},
  actions: {
    async init ()
    {
      this.loading = true
      const productStore = useProductsStore()
      await productStore.loadModelsFromApi()
      this.loading = false
      this.initialized = true
    }
  }
})
